import { Component } from "@angular/core";
import {MatDialogRef as MatDialogRef } from "@angular/material/dialog";

@Component({
  standalone:true,
  selector: "app-confirmation-dialog",
  template: `
    <div class="swal2-popup swal2-modal swal2-show" style="display: flex">
      <div class="swal2-header">
        <div
          class="swal2-icon swal2-warning swal2-animate-warning-icon"
          style="display: flex"
        ></div>
        <h2 class="swal2-title" id="swal2-title" style="display: flex">
          You have unsaved changes
        </h2>
      </div>
      <div class="swal2-content">
        <div id="swal2-content" style="display: block">
          What would you like to do?
        </div>
      </div>

      <div class="swal2-actions">
        <button
          type="button"
          class="swal2-cancel btn btn-default"
           style="display: inline-block;"
          (click)="onClickCancel()">
          STAY ON FORM</button
        ><button
          type="button"
          class="swal2-confirm btn btn-danger"
           style="display: inline-block;"
          (click)="onClickConfirm()">
           LEAVE WITHOUT SAVING
        </button>
      </div> 
    </div>
  `,
})
export class ConfirmationComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<any, boolean>
  ) {}

  onClickCancel() {
    this.dialogRef.close(false);
  }

  onClickConfirm() {
    this.dialogRef.close(true);
  }
}
